import { required, composeSyncValidators } from 'react-admin'

export default (_required = true, validators = []) => {
  return composeSyncValidators([
    _required && required(),
    ...validators,
  ].filter(Boolean))
}
